<app-header [forceLightBackground]="true"></app-header>
<div class="admin-new-requests">
  <div class="admin-new-requests--layout">
    <app-admin-sidebar class="admin-new-requests--sidebar"></app-admin-sidebar>
    <div class="admin-new-requests--content">
      <app-page-header></app-page-header>
      <div class="new-requests-container">
        <div class="tabs-header">
          <div class="tabs-header--left"></div>
          @if (workspace.canViewPlatformSuperset()) {
          <div class="view-toggle">
            <button
              type="button"
              class="view-toggle-btn"
              [class.active]="!showAnalytics"
              (click)="toggleAnalyticsView(false)"
              aria-label="Table View"
              title="Table View"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" stroke-width="2"></rect>
                <line x1="3" y1="10" x2="21" y2="10" stroke="currentColor" stroke-width="2"></line>
                <line x1="9" y1="10" x2="9" y2="20" stroke="currentColor" stroke-width="2"></line>
                <line x1="15" y1="10" x2="15" y2="20" stroke="currentColor" stroke-width="2"></line>
              </svg>
            </button>
            <button
              type="button"
              class="view-toggle-btn"
              [class.active]="showAnalytics"
              (click)="toggleAnalyticsView(true)"
              aria-label="Superset View"
              title="Superset View"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M4 19L10 13L14 17L20 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M20 11V7H16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </button>
          </div>
          }
        </div>

        <div class="analytics-panel" *ngIf="showAnalytics">
          <div class="analytics-panel--body">
            <div class="analytics-panel--loading" *ngIf="analyticsLoading">
              <div class="analytics-panel--spinner"></div>
              <span>Loading dashboard...</span>
            </div>

            <div class="analytics-panel--error" *ngIf="analyticsError && !analyticsLoading">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                <circle cx="12" cy="16" r="1" fill="currentColor"/>
              </svg>
              {{ analyticsError }}
            </div>

            <div
              #analyticsMount
              class="analytics-panel--mount"
              [class.hidden]="analyticsLoading || !!analyticsError"
            ></div>
          </div>
        </div>

        <ng-container *ngIf="!showAnalytics">
        <!-- Filter Section -->
        <app-filter-panel
          [fields]="filterFields"
          [defaultExpanded]="false"
          (filterChange)="onFilterChange($event)"
          (clearFilters)="onClearFilters()"
        ></app-filter-panel>

        <!-- Table -->
        <app-table
          [columns]="columns"
          [data]="requestsData"
          [dropdownOpenRowIndex]="openDropdownRowIndex"
          [scrollable]="true"
          [scrollHeight]="'none'"
          [loading]="loading"
          [pagination]="pagination"
          [emptyMessage]="emptyMessage"
          [striped]="true"
          [bordered]="true"
          [hoverable]="true"
          [showExportButton]="true"
          (export)="onExport()"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          (sortChange)="onSortChange($event)"
        >
          <!-- Custom Action Column (dropdown in fixed overlay below) -->
          <ng-template #actionCell let-row let-rowIndex="rowIndex">
            <div class="action-cell-wrapper">
              <button 
                class="action-btn" 
                (click)="toggleActionDropdown($event, row, rowIndex)"
                [class.active]="isDropdownOpen(rowIndex)"
              >
                <span>Action</span>
              </button>
            </div>
          </ng-template>
        </app-table>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- Fixed overlay: dropdown on top of table -->
<div
  *ngIf="dropdownPosition && openDropdownRow"
  class="action-dropdown-overlay"
  [style.top.px]="dropdownPosition.top"
  [style.left.px]="dropdownPosition.left"
  [style.right.px]="dropdownPosition.right"
  (click)="$event.stopPropagation()"
>
  <ul class="dropdown-list">
    <li class="dropdown-item">
      <button type="button" class="dropdown-link" (click)="handleAction('view', openDropdownRow)">
        View
      </button>
    </li>
    <li class="dropdown-item">
      <button
        type="button"
        class="dropdown-link"
        [class.disabled]="isRequestProcessed(openDropdownRow)"
        [disabled]="isRequestProcessed(openDropdownRow)"
        (click)="!isRequestProcessed(openDropdownRow) && handleAction('approve', openDropdownRow)"
      >
        Approve
      </button>
    </li>
    <li class="dropdown-item">
      <button
        type="button"
        class="dropdown-link"
        [class.disabled]="isRequestProcessed(openDropdownRow)"
        [disabled]="isRequestProcessed(openDropdownRow)"
        (click)="!isRequestProcessed(openDropdownRow) && handleAction('reject', openDropdownRow)"
      >
        Reject
      </button>
    </li>
  </ul>
</div>

<!-- Confirmation Dialog for Approve -->
<app-confirmation-dialog
  [(visible)]="isApproveConfirmationVisible"
  type="info"
  title="Approve Request"
  [message]="getApproveMessage()"
  confirmLabel="Approve"
  cancelLabel="Cancel"
  themeColor="green"
  (onConfirm)="onApproveConfirm()"
  (onCancel)="onApproveCancel()"
  (onClose)="onApproveCancel()"
></app-confirmation-dialog>

<!-- Confirmation Dialog for Reject -->
<app-confirmation-dialog
  [(visible)]="isRejectConfirmationVisible"
  type="warning"
  title="Reject Request"
  [message]="getRejectMessage()"
  confirmLabel="Reject"
  cancelLabel="Cancel"
  themeColor="red"
  (onConfirm)="onRejectConfirm()"
  (onCancel)="onRejectCancel()"
  (onClose)="onRejectCancel()"
></app-confirmation-dialog>

<!-- View Request Modal -->
<app-modal
  [(visible)]="isViewModalVisible"
  [headerTemplate]="viewModalHeaderTemplate"
  [width]="'90vw'"
  [modal]="true"
  [closable]="true"
  [showFooter]="false"
  (onClose)="closeViewModal()"
>
  <app-data-provider-entity-form
    [formData]="viewFormData"
  ></app-data-provider-entity-form>
</app-modal>

<!-- View Modal Header Template with Status Chip -->
<ng-template #viewModalHeaderTemplate>
  <div class="modal-header-with-status">
    <span class="modal-header-title">Organisation Details</span>
    <div *ngIf="selectedRequest?.requestStatus" [ngClass]="getStatusChipClass(selectedRequest?.requestStatus || '')" class="modal-header-status-chip">
      {{ selectedRequest?.requestStatus }}
    </div>
  </div>
</ng-template>